module.exports = __webpack_public_path__ + "static/media/35.7c139318.mp3";